/* eslint-disable import/no-anonymous-default-export */
export default (institutionStats = [], action) => {
  switch (action.type) {
    case "GET_INVESTMENT_INSTITUTION_STATS":
      return action.payload;

    default:
      return institutionStats;
  }
};
